"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _classnames = _interopRequireDefault(require("classnames"));

var _baseModule = _interopRequireDefault(require("./base.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Headline = function Headline(_ref) {
  var variant = _ref.variant,
      component = _ref.component,
      text = _ref.text,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? undefined : _ref$color,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$section = _ref.section,
      section = _ref$section === void 0 ? 'pc' : _ref$section,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align;
  var classes = (0, _classnames.default)(_baseModule.default[component], _baseModule.default[color], _baseModule.default.headline, _baseModule.default[section], (0, _defineProperty2.default)({}, className, className));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
    align: align,
    className: classes,
    variant: variant,
    component: component,
    children: text
  });
};

var _default = Headline;
exports.default = _default;